import { state } from './types';

export default {
  [state.COLLECTION]: {},
  [state.COHORTS]: [],
  [state.VISIBLE_COHORTS]: [],
  [state.DATA]: [],
  [state.RAW_DATA]: [],
  [state.OUTCOME_VARIABLES]: [],
  [state.IS_LOADING]: false,
  [state.DETAILED_VIEW]: null,
  [state.PVAL_THRESHOLD]: 0.05,
  [state.ANOVA_PVALS]: [],
  [state.ANOVA_PVALS_INPUT]: null,
  [state.SCREEN_RESIZE]: false,
  [state.SELECTED_ANALYSIS_MODE]: 'Predictor based',
};
